import { render, staticRenderFns } from "./WebsiteSideNavItems.vue?vue&type=template&id=792130c2"
import script from "./WebsiteSideNavItems.vue?vue&type=script&lang=ts"
export * from "./WebsiteSideNavItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports